module.exports = __webpack_public_path__ + "img/ir-1.fdaf53f3.png";